import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent {

  @Input() title: string = '';
  @Input() isMandatory: boolean = false;
  @Input() isConditionFilled: boolean = false;
  @Input() disabled: boolean = false;
  @Input() fontSize: number = 11
}
